import { create } from "zustand";
import type { SessionUser } from "../types";

export interface Toast {
  id: number;
  title: string;
  body?: string;
  tone?: "success" | "error" | "info";
}

interface UiState {
  user: SessionUser | null;
  setUser: (user: SessionUser | null) => void;
  sidebarOpen: boolean;
  setSidebarOpen: (open: boolean) => void;
  accent: string;
  setAccent: (color: string) => void;
  toasts: Toast[];
  pushToast: (toast: Omit<Toast, "id">) => void;
  dismissToast: (id: number) => void;
}

let toastId = 1;

export const useUi = create<UiState>((set) => ({
  user: null,
  setUser: (user) => set({ user }),
  sidebarOpen: false,
  setSidebarOpen: (sidebarOpen) => set({ sidebarOpen }),
  accent: "#EC4899",
  setAccent: (accent) => {
    const hex = accent.replace("#", "");
    const r = Number.parseInt(hex.slice(0, 2), 16);
    const g = Number.parseInt(hex.slice(2, 4), 16);
    const b = Number.parseInt(hex.slice(4, 6), 16);
    document.documentElement.style.setProperty("--accent", `${r} ${g} ${b}`);
    set({ accent });
  },
  toasts: [],
  pushToast: (toast) => {
    const id = toastId++;
    set((state) => ({ toasts: [...state.toasts, { ...toast, id }].slice(-4) }));
    window.setTimeout(() => {
      set((state) => ({ toasts: state.toasts.filter((item) => item.id !== id) }));
    }, 4500);
  },
  dismissToast: (id) => set((state) => ({ toasts: state.toasts.filter((item) => item.id !== id) })),
}));

export function toast(input: Omit<Toast, "id">) {
  useUi.getState().pushToast(input);
}

export function toastSuccess(title: string, body?: string) {
  toast({ title, body, tone: "success" });
}

export function toastError(title: string, body?: string) {
  toast({ title, body, tone: "error" });
}

export function toastInfo(title: string, body?: string) {
  toast({ title, body, tone: "info" });
}
